import { useMediaQuery } from '@mui/material';
import React, { useEffect } from 'react';
import { Navigate, redirect, Route, Routes, useLocation } from 'react-router-dom';
import AppLayout from '../../Components/AppLayout';
import NestedPageLayout from '../../Components/NestedPageLayout';
import { PrivateRoute, PublicRoute } from '../../Utils/helperFunctions';
import routes from '../../Utils/routes';

import AuthLayout from '../../Components/AuthLayout';
import NotFound from '../404';
import MainScreen from '../MainScreen';
import TermsAndConditions from '../IdeaBaazApplication/components/termsAndConditions';
import PrivacyPolicy from '../IdeaBaazApplication/components/privacyPolicy';
import FAQ from '../IdeaBaazApplication/components/faqs';
import { Mixpanel } from '../../Helpers/mixpanel';

// auth
const Login = React.lazy(() => import('../Auth/Login/index'));
const Signup = React.lazy(() => import('../Auth/SignUp'));

// dashboard
const Home = React.lazy(() => import('../Home'));
const P47Application = React.lazy(() => import('../P47Application/Index'));
const IdeaBazzApplication = React.lazy(() => import('../IdeaBaazApplication/Index'));
const OptionPage = React.lazy(() => import('../OptionPage/index'));
const OtpVerification = React.lazy(() => import('../Auth/VerifyOtp'));
const Summary = React.lazy(() => import('../Summary/Index'));

const MainLayout: React.FunctionComponent = () => {
  const location = useLocation();

  useEffect(() => {
    Mixpanel.track('Page View', {
      path: location.pathname,
    });
  }, [location]);

  const isMobile = useMediaQuery('(max-width:700px)');

  const ResponsiveLayout = ({ children }: any) => {
    return isMobile ? <NestedPageLayout>{children}</NestedPageLayout> : <AppLayout>{children}</AppLayout>;
  };

  return (
    <>
      <Routes>
        {/* Initial Route */}
        <Route path={'/'} element={<MainScreen />} />
        <Route path="/register-form" element={<Navigate to="/signup" />} />

        <Route path={routes.termsAndConditions} index element={<TermsAndConditions />} />

        <Route path={routes.privacyPolicy} index element={<PrivacyPolicy />} />

        {/* <Route
          path={routes.optionPage}
          index
          element={
            <PrivateRoute>
              <OptionPage />
            </PrivateRoute>
          }
        /> */}
        <Route
          path={routes.home}
          index
          element={
            <PrivateRoute>
              <AppLayout>
                <Home />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.faqs}
          index
          element={
            <PrivateRoute>
              <AppLayout>
                <FAQ />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path={routes.P47Application}
          index
          element={
            <PrivateRoute>
              <P47Application />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.summary}
          element={
            <PrivateRoute>
              <Summary />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.IdeaBazzApplication}
          index
          element={
            <PrivateRoute>
              <IdeaBazzApplication />
            </PrivateRoute>
          }
        />

        <Route
          path={routes.login}
          index
          element={
            <PublicRoute>
              <AuthLayout>
                <Login />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.signup}
          index
          element={
            <PublicRoute>
              <AuthLayout>
                <Signup />
              </AuthLayout>
            </PublicRoute>
          }
        />

        <Route
          index
          path={routes.otpverification}
          element={
            <AuthLayout>
              <OtpVerification />
            </AuthLayout>
          }
        />

        <Route path={'*'} element={<NotFound />} />
      </Routes>
    </>
  );
};

export default MainLayout;
